import React from "react";
import "../../stylesheets/components/Generic/ClientTier.scss";
import GoldNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/GoldNew.svg";
import DiamondNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/DiamondNew.svg";
import BlackNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/BlackNew.svg";
import BlueNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/BlueNew.svg";
import BronzeNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/BronzeNew.svg";
import SilverNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/SilverNew.svg";
import PlatinumNew from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/PlatinumNew.svg";
var ClientTier = function (props) {
    var _a;
    var checkClientTier = (_a = props === null || props === void 0 ? void 0 : props.clientTier) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    var generateIcons = function (ClientTier) {
        switch (ClientTier) {
            case "diamond":
                return React.createElement("img", { src: DiamondNew, alt: "Diamond" });
            case "black":
                return React.createElement("img", { src: BlackNew, alt: "Black" });
            case "platinum":
                return React.createElement("img", { src: PlatinumNew, alt: "Platinum" });
            case "gold":
                return React.createElement("img", { src: GoldNew, alt: "Gold" });
            case "silver":
                return React.createElement("img", { src: SilverNew, alt: "Silver" });
            case "bronze":
                return React.createElement("img", { src: BronzeNew, alt: "Bronze" });
            case "blue":
                return React.createElement("img", { src: BlueNew, alt: "Blue" });
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var generateColouredIcons = function (hoverClass, nonHoverClass, textClassName, largeIconClass) {
        return (React.createElement("div", { className: "client-tier-container ".concat((props === null || props === void 0 ? void 0 : props.hoverClass) ? hoverClass : nonHoverClass, " ").concat((props === null || props === void 0 ? void 0 : props.parentClassName) ? props === null || props === void 0 ? void 0 : props.parentClassName : "", "\n    ") },
            React.createElement("span", { className: "client-tier-text ".concat(props === null || props === void 0 ? void 0 : props.tierTextClass, " ").concat(textClassName) }, checkClientTier === null || checkClientTier === void 0 ? void 0 : checkClientTier.toUpperCase()),
            React.createElement("div", { className: "client-tier-icon-block ".concat(largeIconClass ? largeIconClass : "") }, generateIcons(checkClientTier))));
    };
    if (props === null || props === void 0 ? void 0 : props.showOnlyIcon) {
        return generateIcons(checkClientTier);
    }
    else {
        switch (checkClientTier) {
            case "diamond":
                return generateColouredIcons("diamond-hover-class", "diamond-coloured-class", "diamond-class", "large-tier-icon");
            case "black":
                return generateColouredIcons("black-hover-class", "black-coloured-class", "black-class");
            case "platinum":
                return generateColouredIcons("platinum-hover-class", "platinum-coloured-class", "platinum-class");
            case "gold":
                return generateColouredIcons("gold-hover-class", "gold-coloured-class", "gold-class");
            case "silver":
                return generateColouredIcons("silver-hover-class", "silver-coloured-class", "silver-class");
            case "bronze":
                return generateColouredIcons("bronze-hover-class", "bronze-coloured-class", "bronze-class");
            case "blue":
                return generateColouredIcons("blue-hover-class", "blue-coloured-class", "blue-class");
            default:
                return React.createElement(React.Fragment, null);
        }
    }
};
export default ClientTier;
